module.exports = require("./kw-GB.js");